<template>
	<section class="work-section" id="about">
		<h3 class="h-text">
			<span>Мы занимаемся перевозкой грузов</span>
			<span class="h-text2"> из Китая в Россию</span>
		</h3>

		<ul class="cases">
			<li
				v-for="item in cases"
				:key="item.text"
				class="case scroll-animation"
			>
				<p>{{ item.text }}</p>

				<div v-if="item.image" class="image" />
				<div v-if="item.icon" class="icon">
					<UIShIcon :name="item.icon" />
				</div>
			</li>
		</ul>

		<ul class="stat">
			<li v-for="val in values" :key="val.name" class="scroll-animation">
				<p>{{ val.name }}</p>
				<b>{{ val.value }}</b>
			</li>
		</ul>
	</section>
</template>

<script setup lang="ts">
const cases = [
	{
		icon: 'briefcase-01',
		text: 'Предоставляем услуги для молодых компаний и для организаций с небольшим оборотом денежных средств'
	},
	{
		icon: 'file-check-02',
		text: 'Займемся таможенным оформлением и подготовкой прочих документов, вам останется только получить товар'
	},
	{
		image: '/images/store.png',
		text: 'Склады для хранения\nгруза находятся в России'
	}
];

const values = [
	{ name: 'Минимальный вес', value: '10 кг' },
	{ name: 'Стоимость', value: '1200 ₽/кг' },
	{ name: 'Частота отгрузок', value: '2 раза в неделю' }
];
</script>

<style lang="scss" scoped>
.work-section {
	margin-top: 4.444rem;
}

.h-text {
	@include useFont(dxsb);
	text-transform: uppercase;
	color: var(--color-white);
	max-width: 15.944rem;

	&2 {
		color: var(--color-gray300);
	}
}

.cases {
	display: flex;
	flex-direction: column;
	gap: 0.667rem;
	margin-top: 1.333rem;

	.case {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 1.333rem;
		width: 100%;
		height: 100%;
		padding: 0.889rem;
		border-radius: 1.111rem;
		color: var(--color-white);
		border: 0.056rem solid var(--color-white30);
		position: relative;
		@include useFont(tsmm);
		white-space: pre-line;

		&:has(.image) {
			border: 0;
			height: 10.667rem;
			justify-content: flex-end;
			background-image:
				linear-gradient(
					227.22deg,
					rgba(0, 0, 0, 0) 11.34%,
					#000000 109.89%
				),
				url('/images/store.png');
			background-size: cover;
			background-repeat: no-repeat;
		}

		p {
			max-width: 16.889rem;
		}

		.icon {
			--icon-width: 1rem;
			--icon-height: 1rem;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: auto;
			border-radius: 2.667rem;
			color: var(--color-brand500);
			background-color: var(--color-black50);
			@include useFixedSize(2.667rem, 2.667rem);
		}

		.image {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: inherit;
			object-fit: cover;
			z-index: -1;
		}
	}
}

.stat {
	display: flex;
	gap: 0.667rem;
	margin-top: 0.667rem;
	flex-wrap: wrap;

	li {
		flex: 1;
		padding: 0.889rem;
		border-radius: 1.111rem;
		@include useFont(tsmm);
		color: var(--color-gray300);
		background-color: var(--color-gray900);

		&:last-of-type {
			width: 100%;
			min-width: 18.667rem;
			color: var(--color-brand200);
			background-color: var(--color-brand500);
		}

		b {
			display: block;
			margin-top: 0.222rem;
			color: var(--color-white);
			@include useFont(txlb);
			text-transform: uppercase;
		}
	}
}

@include screen1920 {
	.work-section {
		margin-top: 7.778rem;
	}

	.h-text {
		max-width: 60.833rem;
		@include useFont(dxlb);
	}

	.cases {
		display: grid;
		column-gap: 1.111rem;
		margin-top: 2.667rem;
		grid-template-rows: 22.056rem;
		grid-template-columns: 24.722rem 24.722rem 1fr;

		.case {
			padding: 1.778rem;
			border-radius: 1.333rem;
			@include useFont(txlm);

			&:has(.image) {
				height: 100%;
			}

			.icon {
				--icon-width: 1.333rem;
				--icon-height: 1.333rem;
				border-radius: 3.556rem;
				@include useFixedSize(3.556rem, 3.556rem);
			}
		}
	}

	.stat {
		display: grid;
		column-gap: 20px;
		margin-top: 1.611rem;
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: 7.778rem;

		li {
			padding: 1.778rem;
			border-radius: 1.333rem;
			@include useFont(txlm);

			b {
				margin-top: 0.444rem;
				@include useFont(dsmb);
			}
		}
	}
}
</style>
